import { routes as storeLocationRoutes } from "./store-location/routes";
import { routes as shelvesRoutes } from "./shelves/routes";
import { routes as packagingRoutes } from "./packaging/routes";
import { routes as priceSchemes } from "./price-scheme/routes";
import { routes as stockAdjustmentTypesRoutes } from "./stock-adjustment-types/routes";
import { routes as itemCategoryRoutes } from "./item-category/routes";
import { routes as itemGroupRoutes } from "./item-group/routes";
import { routes as itemTypeRoutes } from "./item-types/routes";
import { routes as supplierJournalCategoriesRoutes } from "./supplier-journal-categories/routes";
import { routes as coasRoutes } from "./coas/routes";
import { routes as financialPeriodRoutes } from "./financial-periods/routes";
import { routes as expenseItemsRoutes } from "./expenseItems/routes";

export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts`,
        name: `${prefix}.accounts.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.index`,
                PageDescription: "Accounts master data",
            },
        },
    },
    ...storeLocationRoutes(prefix),
    ...shelvesRoutes(prefix),
    ...packagingRoutes(prefix),
    ...priceSchemes(prefix),
    ...stockAdjustmentTypesRoutes(prefix),
    ...itemCategoryRoutes(prefix),
    ...itemGroupRoutes(prefix),
    ...itemTypeRoutes(prefix),
    ...supplierJournalCategoriesRoutes(prefix),
    ...coasRoutes(prefix),
    ...financialPeriodRoutes(prefix),
    ...expenseItemsRoutes(prefix)
];